import * as yup from "yup";

const validation = yup.object().shape({
  is_ckyc_no: yup.mixed().required("Please select Yes or No"),

  ckyc_no: yup
    .string()
    .nullable()
    .when("is_ckyc_no", {
      is: (val) => val === "Y",
      then: () => yup.string().required("CKYC Number is required"),
      otherwise: () => yup.string().nullable(),
    }),

  POI_Type: yup.string().when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
    is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
    then: () => yup.string().required("Proof of Identity Type is required"),
  }),

  POI_ID: yup.string().when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
    is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
    then: () => yup.string().required("Identity Proof Number is required"),
  }),

  POI_DocumentFile: yup
    .mixed()
    .when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
      is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
      then: () =>
        yup.mixed().required("Proof of Identity document is required"),
    }),

  POA_Type: yup.string().when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
    is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
    then: () => yup.string().required("Proof of Address Type is required"),
  }),

  POA_ID: yup.string().when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
    is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
    then: () => yup.string().required("Address Proof Number is required"),
  }),

  method_of_verification: yup
    .string()
    .nullable()
    .when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
      is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
      then: () => yup.string().required("This field is required"),
    }),

  pan_no: yup
    .string()
    .trim()
    .nullable()
    .when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
      is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
      then: () =>
        yup
          .string()
          .required("PAN number is required")
          .matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN format. Example: ABCDE1234F",
          ),
    }),

  address_proof: yup.string().nullable(),
  identity_proof: yup.string().nullable(),
  address_proof_front_doc: yup.mixed().nullable(),
  address_proof_back_doc: yup.mixed().nullable(),
  identity_proof_front_doc: yup.mixed().nullable(),
  identity_proof_back_doc: yup.mixed().nullable(),
  photo_doc: yup.mixed().nullable(),

  POA_DocumentFile: yup
    .mixed()
    .when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
      is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
      then: () => yup.mixed().required("Proof of Address document is required"),
    }),

  Insured_photo: yup
    .mixed()
    .when(["is_ckyc_no", "product_data.INSURANCE_SLUG"], {
      is: (is_ckyc_no, slug) => is_ckyc_no === "N" && slug === "shri_ram",
      then: () => yup.mixed().required("Photo is required"),
    }),
});

export default validation;
